import { Quotation } from 'data-layer-cr/dist/models';
import typeIntermediary, {
  typeOfMoney,
} from 'src/constants/selectValidationPaymentEmission';

export const verifyBranchOffice = (quotation: Quotation): boolean =>
  [quotation.user.license, quotation.brokerLicense].includes(
    process.env.REACT_APP_DEFAULT_BROKER_LICENSE as string,
  );

const selectValidationPaymentEmission = (quotation: Quotation): string => {
  const { quotationProfile } = quotation;
  const isBranchOffice = verifyBranchOffice(quotation);
  if (isBranchOffice) {
    return typeIntermediary.withBranchOffice;
  }
  if (typeOfMoney.colones === quotationProfile?.typeOfMoney) {
    return typeIntermediary.noBranchOfficeColones;
  }
  return typeIntermediary.noBranchOfficeDollars;
};

export default selectValidationPaymentEmission;
